import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup, ValidatorFn, AsyncValidatorFn, FormBuilder, AbstractControl, ValidationErrors, Validators } from '@angular/forms';
import CustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { OperazioniDisponibili, Soggetto, FirRemoto, OutputEventCampiInit, OutputEventCampiStatus, OutputEventCampiErrors, OutputEventCampiValue } from '../../interfaces';
import { Apiservice } from '../../../../services/api.service';
import { alert } from 'devextreme/ui/dialog';
import { ComponentService } from '../../../../services/component.service';
import { DocumentTask, FirDigitaliTransactionService, TransactionStateMap } from '../../../../services/fir-digitali-transaction.service';
import { InputFileElComponent } from '../../../nica-form/editor-element/input-file-el/input-file-el.component';

@Component({
  selector: 'app-aggiungi-allegato',
  templateUrl: './aggiungi-allegato.component.html',
  styleUrls: ['./aggiungi-allegato.component.css']
})
export class AggiungiAllegatoComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('inputFile', { static: false }) inputFile: ElementRef<HTMLInputElement>
  @Input() operazioniDisponibili: OperazioniDisponibili
  @Input() soggetto: Soggetto
  @Input() group: Array<"Allegato">;
  @Input() firRemoto: FirRemoto
  @Input() sezioneGroup: string
  @Input() meta: { [key: string]: boolean } = {}
  @Output() initGroup = new EventEmitter<OutputEventCampiInit>();
  @Output() statusChange = new EventEmitter<OutputEventCampiStatus>();
  @Output() errorsChange = new EventEmitter<OutputEventCampiErrors>();
  @Output() valueChange = new EventEmitter<OutputEventCampiValue>();
  protected formGroups: FormGroup = this.fb.group({})
  // protected isDisabled: boolean = false
  protected currentGroup: string = ''
  protected fields: Record<string, {
    label: string;
    validators?: ValidatorFn[];
    asyncValidators?: AsyncValidatorFn[];
    items?: {
      dataSource?: DataSource | any[];
      displayExpr?: string | ((item: any) => string);
      valueExpr?: string | ((item: any) => string);
    }
  }>
  private destroy$ = new Subject<void>();

  constructor(
    private readonly fb: FormBuilder,
    private readonly Apiservice: Apiservice,
    private readonly ComponentService: ComponentService,
    private readonly FirTransaction: FirDigitaliTransactionService) { }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
  ngAfterViewInit(): void {
    console.log(this)
    this.initGroup.emit({
      name: 'onInit',
      value: this.formGroups.value,
      formGroups: this.formGroups,
      sezione: this.sezioneGroup,
      component: this, touched: this.isFormTouched()
    })
  }

  ngOnInit() {
    if (!this.group || !this.soggetto || !this.operazioniDisponibili || !this.firRemoto) alert('Errore', 'Attenzione');
    else {
      this.currentGroup = 'Allegato'
      this.processFieldsMetadata();
      this.processFormGroup()

      this.formGroups.statusChanges
        .pipe(takeUntil(this.destroy$))
        .subscribe(() => this.emitEvents());

      this.formGroups.valueChanges
        .pipe(takeUntil(this.destroy$))
        .subscribe(value => {
          this.valueChange.emit({ name: 'valueChange', formGroups: this.formGroups, value: value, sezione: this.sezioneGroup, component: this, touched: this.isFormTouched() });
          this.emitEvents();
        });
      // this.FirTransaction.globalQueue$.pipe(takeUntil(this.destroy$)).subscribe({
      //   next: (next: DocumentTask[]) => {
      //     this.isDisabled = next.length > 0 ? next.some((task) => (task.status !== 'error' && task.status !== 'completed') ?
      //       this.group.includes(task.processId as any) : false) : false
      //   },
      // })
      // this.FirTransaction.state$.pipe(takeUntil(this.destroy$)).subscribe({
      //   next: (next: TransactionStateMap) => {
      //     this.isDisabled = next[this.firRemoto.dati_partenza.numero_fir] ?
      //       (next[this.firRemoto.dati_partenza.numero_fir].status !== 'error' && next[this.firRemoto.dati_partenza.numero_fir].status !== 'completed') ?
      //         next[this.firRemoto.dati_partenza.numero_fir].listTask.some((val) => (val.status !== 'completed' && val.status !== 'error') ? this.group.includes(val.processId as any) : false)
      //         : false : false
      //   },
      // })
    }
  }
  onFileSelected(event: Event) {
    if (this.meta[this.currentGroup] === false) return;
    const input = event.target as HTMLInputElement;
    if (!input || !input.files) return;
    const files = input.files
    const group = this.getForm('Allegato');
    if (!group) return;
    if (!files || files.length === 0) return;
    if (this.inputFile) this.inputFile.nativeElement.files = files
    group.patchValue({ allegato: files })
    group.updateValueAndValidity()
  }
  onFileDropped(files: FileList) {
    if (this.meta[this.currentGroup] === false) return;
    if (!files || files.length === 0) return;
    const group = this.getForm('Allegato');
    if (!group) return;
    if (files.length > 1) return alert('È possibile inviare un solo file allegato', 'Attenzione')
    if (this.inputFile) this.inputFile.nativeElement.files = files
    group.patchValue({ allegato: files })
    group.updateValueAndValidity()
  }

  removeFile(index: number) {
    const group = this.getForm('Allegato');
    if (!group) return;
    const input = this.inputFile.nativeElement;
    const dt = new DataTransfer();
    if (!input || !input.files || input.files.length === 0) {
      const currentFiles = group.value; // FileList
      Array.from(currentFiles).forEach((file, i) => {
        if (i !== index) dt.items.add(file as File);
      });
    } else {
      const currentFiles = input.files; // FileList
      Array.from(currentFiles).forEach((file, i) => {
        if (i !== index) dt.items.add(file);
      });
    }
    const newFileList = dt.files;
    input.files = newFileList;
    group.patchValue({ allegato: newFileList });
    group.setErrors(null);
    group.updateValueAndValidity();
  }

  previewFile(file: File) {
    console.log(file);
    // alert('Funzionalità in sviluppo', 'Attenzione');
    const guid = Math.random().toString().replace('0', '')
    this.ComponentService.setNewPopUp(guid, 'NicaPopupPdfComponent', null, '900', null, { file }, false, true, `File: ${file.name}`)
  }
  hasError(actionKey: string, fieldKey: string): boolean {
    const group = this.getForm(actionKey);
    if (!group) return false;
    const control = group.get(fieldKey);
    if (!control) return false;
    if (!control.touched) return false;
    return control.invalid;
  }
  getForm(key: string): FormGroup | null {
    if (!this.formGroups.get(key)) return null
    return this.formGroups.get(key) as FormGroup;
  }
  getValue(key: string, field: string): any | null {
    if (!this.formGroups.get(key)) return null
    const group = this.formGroups.get(key) as FormGroup;
    const campo = group.get(field)
    if (!campo) return null
    return campo.value;
  }
  formatFileSize(sizeInBytes: number, decimals: number = 2): string {
    if (sizeInBytes === 0 || sizeInBytes == null) return '0 B';

    const k = 1024;
    const sizes = ['B', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.floor(Math.log(sizeInBytes) / Math.log(k));

    const value = (sizeInBytes / Math.pow(k, i));

    return `${value.toFixed(decimals)} ${sizes[i]}`;
  }

  //! -------------------------------------------------------------------------
  private isFormTouched(): boolean {
    for (const actionKey of this.group) {
      if (this.meta[actionKey] === false) continue;
      const group = this.getForm(actionKey);
      if (!group) continue;
      const controls = Object.entries(group.controls);
      const values = controls.map(([_, ctrl]) => (ctrl.value as FileList || new FileList()));
      const hasValue = values.some(v => v.length > 0);
      if (hasValue) return true
    }
    return false;
  }

  private maxSizeValidator(maxMB: number): ValidatorFn {
    return control => {
      const file: File[] = control.value;
      if (!file || file.length === 0) return null;
      return file[0].size <= maxMB * 1024 * 1024 ? null : { maxSize: true, allowedSize: maxMB };
    };
  }
  private fileTypeValidator(types: string[]): ValidatorFn {
    return control => {
      const file: File[] = control.value;
      if (!file || file.length === 0) return null;
      return types.includes(file[0].type) ? null : { fileType: true, allowedTypes: types.map(t => t.split('/')[1]) };
    };
  }
  private maxFile(n: number): ValidatorFn {
    return control => {
      const file: File[] = control.value;
      if (!file || file.length === 0) return null;
      return file.length <= n ? null : { multiFile: true, maxFile: n };
    };
  }

  private emitEvents(): void {
    const messages = []
    for (const actionKey of this.group) {
      if (this.meta[actionKey] === false) continue;
      const group = this.getForm(actionKey);
      if (!group) continue;

      const value = group.getRawValue();
      for (const field of Object.keys(value)) {
        const msg = this.getErrorMessage(actionKey, field);
        if (msg) messages.push(msg);
      }
    }
    const status = this.formGroups.status === 'VALID' ? 'VALID' : 'INVALID';
    this.statusChange.emit({ name: 'statusChange', status, formGroups: this.formGroups, sezione: this.sezioneGroup, component: this, touched: this.isFormTouched() });
    this.errorsChange.emit({ name: 'errorsChange', errors: messages, formGroups: this.formGroups, sezione: this.sezioneGroup, component: this, touched: this.isFormTouched() });
  }

  getErrorMessage(actionKey: string, field: string): string | null {
    const group = this.getForm(actionKey);
    const control = group.get(field);
    if (!control || !control.errors) return null;
    const errors = control.errors;
    const fallbackMessages: Record<string, (err: any) => string> = {
      required: () => `Campo ${this.fields[field].label} obbligatorio`,
      minlength: err => `Campo ${this.fields[field].label} minimo ${err.requiredLength} caratteri`,
      maxlength: err => `Campo ${this.fields[field].label} massimo ${err.requiredLength} caratteri`,
      min: err => `Campo ${this.fields[field].label} valore minimo ${err.min}`,
      max: err => `Campo ${this.fields[field].label} valore massimo ${err.max}`,
      pattern: () => `Campo ${this.fields[field].label} non valido`,
      custom: err => typeof err === 'string' ? err : `${this.fields[field].label} non valido`,
      async: err => typeof err === 'string' ? err : `${this.fields[field].label} non valido`,
      maxSize: () => `Il file caricato come ${this.fields[field].label} supera la dimensione massima consentita di ${errors['allowedSize']} MB`,
      fileType: () => `Il file caricato come ${this.fields[field].label} non è del tipo consentito (${(errors['allowedTypes'] || []).join(', ')})`,
      multiFile: () => `È possibile caricare un solo file ${this.fields[field].label}`,
    };
    for (const key of Object.keys(errors)) {
      const err = errors[key];
      if (fallbackMessages[key]) return fallbackMessages[key](err);
    }
    return `Campo non valido`;
  }

  private dynamicGroupActivation(
    validatorsMap: Record<string, ValidatorFn[]>
  ): ValidatorFn {
    return (group: AbstractControl): ValidationErrors | null => {
      if (!(group instanceof FormGroup)) return null;
      const controls = Object.entries(group.controls);
      const values = controls.map(([_, ctrl]) => {
        const v = ctrl.value;
        if (v instanceof File) return true;
        if (v === null || v === undefined) return false;
        return v.toString().trim() !== '';
      });

      const hasValue = values.some(v => v);

      for (const [field, ctrl] of controls) {
        const originalValidators = validatorsMap[field] || [];
        if (hasValue) {
          ctrl.setValidators(originalValidators);
        } else {
          ctrl.clearValidators();
        }
        ctrl.updateValueAndValidity({ emitEvent: false, onlySelf: true });
      }
      return null;
    };
  }

  private processFormGroup() {
    for (const key of this.group) {
      const subGroup = this.fb.group({});
      this.formGroups.addControl(key, subGroup);
      this.buildForm(subGroup, key);
    }
  }

  private buildForm(subGroup: FormGroup, operazione: string) {
    subGroup.addControl('allegato', this.fb.control([]));
    const validatorsMap: Record<string, ValidatorFn[]> = {};
    for (const fieldName of Object.keys(subGroup.controls)) {
      validatorsMap[fieldName] = this.fields[fieldName].validators || [];
    }
    if (this.meta[operazione] === false) return;
    else return subGroup.setValidators(this.dynamicGroupActivation(validatorsMap));
  }

  private processFieldsMetadata() {
    this.fields = {
      allegato: {
        label: 'Allegato',
        validators: [
          this.maxSizeValidator(1),
          this.fileTypeValidator(['application/pdf']),
          this.maxFile(1)
        ]
      }
    }
  }

}
